import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=7b736edb"
import script from "./electric.vue?vue&type=script&lang=js"
export * from "./electric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports